import React, { useEffect, useState } from 'react';
const COLORS = ['#E32F6E', '#D2A96E', '#2E7D52', '#FFB3C8', '#F5D9A8'];
const PIECE_COUNT = 80;
type Piece = {
  left: number;
  delay: number;
  duration: number;
  color: string;
  rotate: number;
  width: number;
  height: number;
};
export function Confetti() {
  const [pieces, setPieces] = useState<Piece[]>([]);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const generated: Piece[] = Array.from({
      length: PIECE_COUNT
    }).map(() => ({
      left: Math.random() * 100,
      delay: Math.random() * 1.5,
      duration: 2.5 + Math.random() * 2,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      rotate: Math.random() * 360,
      width: 6 + Math.random() * 8,
      height: 10 + Math.random() * 8
    }));
    setPieces(generated);
    // Remove from DOM after animation finishes (~5s total)
    const timeout = setTimeout(() => setVisible(false), 5500);
    return () => clearTimeout(timeout);
  }, []);
  if (!visible) return null;
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-50 overflow-hidden" data-id="element-8">
      {pieces.map((p, i) => <span key={i} className="confetti-piece" style={{
      left: `${p.left}%`,
      backgroundColor: p.color,
      width: `${p.width}px`,
      height: `${p.height}px`,
      animationDelay: `${p.delay}s`,
      animationDuration: `${p.duration}s`,
      transform: `rotate(${p.rotate}deg)`
    }} data-id="element-9" />)}
    </div>;
}